export default __webpack_public_path__ + "static/media/1034_1036_new.ebb72a51.jpg";